import React from 'react'
import { TailSpin } from 'react-loader-spinner'

const LoadingSpinner = () => {
    return (
        <TailSpin
            height="60"
            width="60"
            color="#0073ea"
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass="loader"
            visible={true}
        />
    )
}

export default LoadingSpinner